import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Necesito saber de mecánica?',
  a: 'No. Está diseñado específicamente para personas sin conocimientos previos. El lenguaje es 100% claro y sin tecnicismos complicados.'
}, {
  q: '¿Es material digital?',
  a: 'Sí. Recibís acceso inmediato a todo el material en formato digital (PDFs y guías) para ver desde tu celular, tablet o computadora.'
}, {
  q: '¿Sirve para cualquier auto?',
  a: 'Sí. Los principios de mecánica preventiva, cuidado y detección de fallas aplican a todos los vehículos de uso diario (nafta, diesel o GNC).'
}, {
  q: '¿Es un curso técnico?',
  a: 'No. Es un sistema práctico y preventivo enfocado en el usuario común, no para formar mecánicos profesionales, sino para dueños de autos inteligentes.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-16 px-4" data-id="element-36">
      <div className="max-w-3xl mx-auto" data-id="element-37">
        <h2 className="text-3xl font-black text-center text-gray-900 mb-12" data-id="element-38">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-39">
          {faqs.map((faq, idx) => <div key={idx} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-40">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex justify-between items-center p-5 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-41">
                <span className="font-bold text-gray-900 text-lg" data-id="element-42">{faq.q}</span>
                {openIndex === idx ? <ChevronUp className="w-5 h-5" data-id="element-43" /> : <ChevronDown className="w-5 h-5" data-id="element-44" />}
              </button>
              {openIndex === idx && <div className="p-5 bg-white text-gray-700 border-t border-gray-200" data-id="element-45">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}